import { SxStyle } from '@aibees/shared/theme';

export const errorBox: SxStyle = {
  position: 'absolute',
  top: (p) => p.spacing(22),
  width: (p) => p.spacing(43),
};

export const errorIcon: SxStyle = {
  color: (p) => p.palette.error[200],
};

export const allowedText: SxStyle = {
  mx: 'auto',
  display: 'block',
  textAlign: 'center',
  mt: 1,
};

export const errorAlert: SxStyle = {
  background: (p) => p.palette.error[50],
  padding: (p) => p.spacing(0, 2),
  fontSize: (p) => p.typography.caption,
  border: 'none',
};
